<template>
  <div class="conversations__user-details">
    <view-user
      :auths="authsSelectedUser"
      @clearUserIdAndAuths="clearUserIdAndAuths()"
      :customComponent="customComponent"
      :user-id="user.userId"
      v-model="viewUserDialog"
    />
    <div class="user-details__header">
      <div class="hidden-md-and-up">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" @click="goBackToConversation()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.goBack') }}</span>
        </v-tooltip>
      </div>

      <div style="flex-grow: 1">
        {{$t('general.details')}}
      </div>

      <v-btn @click="showUser()"
             color="white"
             icon
             style="cursor: pointer"
             v-if="roomInfo && !(roomInfo.userGuest.includes('@') || roomInfo.userGuest.includes('+') )">
        <v-icon size="27px">
          remove_red_eye
        </v-icon>
      </v-btn>
      <span>
          <v-progress-circular color="white"
                               indeterminate
                               size="20"
                               v-if="loadingUserDetails"
                               width="2">
          </v-progress-circular>
      </span>
    </div>

    <v-divider/>

    <div class="details-container">
      <div class="error-container"
           v-if="error.show">
        <v-icon class="conversations-info-icon">
          {{error.icon}}
        </v-icon>
        <span class="font-weight-bold">{{$t('general.selectPerson')}}</span>
        <span>{{this.roomInfo.user ? this.roomInfo.user.userGuest : this.roomInfo.userGuest}}</span>
      </div>

      <div class="info-container" v-else-if="user">
        <div class="avatar-container d-flex">
          <v-avatar class="my-2"
                    height="100px"
                    width="100px"
                    style="border: solid 2px #00b48e">
            <v-img :src="imageProfile"
                   @error="onErrorImage()"
                   v-if="imageProfile">
            </v-img>
            <v-icon color="#00b48e"
                    size="60px"
                    v-else>
              feather-user
            </v-icon>
          </v-avatar>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="mt-16 mr-3"
                     color="kbDarkBlue"
                     icon
                     target="_blank"
                     v-on="on"
                     absolute
                     top
                     right
                     :href="`http://${tenebitUrl}.tenebit.co/index.php?action=UnifiedSearch&module=Home&search_form=false&advanced=false&query_string=${user.phone}`"
                     width="50"
                     height="50"
                     v-if="tenebitUrl">
                <v-img src="https://storage.googleapis.com/keybe/images/dashboard/tenebit.png" width="30"/>
              </v-btn>
            </template>
            <span>Ir a tenebit</span>
          </v-tooltip>

        </div>
        <div class="d-inline-flex">
          <VBFieldEditor icon="feather-user"
                         :placeholder="$t('general.enterName')"
                         :title="$t('general.name')"
                         @update="updateUser({ field: 'name', value: $event })"
                         :value="user.name">
          </VBFieldEditor>
          <v-chip v-if="user.journeyId"
                  class="align-self-center mt-6"
                  @click="showUser('userJourney')"
                  :color="user.journey.mainColor"
                  label
                  text-color="white"
                  x-small>
            {{ user.journey.name }}
          </v-chip>
        </div>

        <VBFieldEditor icon="feather-mail"
                       :placeholder="$t('general.enterEmail')"
                       :title="$t('general.email')"
                       @update="updateUser({ field: 'email', value: $event })"
                       :value="user.email">
        </VBFieldEditor>

        <VBFieldEditor icon="feather-phone"
                       :placeholder="$t('general.enterPhone')"
                       :title="$t('general.phone')"
                       @update="updateUser({ field: 'phone', value: $event })"
                       :value="user.phone">
        </VBFieldEditor>

        <VBFieldEditor icon="feather-map-pin"
                       :placeholder="$t('general.enterCountry')"
                       read-only
                       :title="$t('general.country')"
                       :value="user.country">
        </VBFieldEditor>

        <VBFieldEditor icon="mdi-fingerprint"
                       read-only
                       title="ID"
                       :value="this.roomInfo.user ? this.roomInfo.user.userGuest : this.roomInfo.userGuest">
        </VBFieldEditor>

        <VBFieldEditor icon="feather-chevrons-right"
                       v-for="extradata in userExtraDatasConversations"
                       :placeholder="`${$t('general.enter')} ${extradata.field}`"
                       :title="$t(extradata.field)"
                       :key="extradata.field"
                       :value="extradata.value"
                       :data="extradata"
                       @update="updateUserInfo({ field: extradata.field, value: $event })">
        </VBFieldEditor>

        <NewExtradata icon="feather-plus"
                      :placeholder="$t('general.enterValue')"
                      @update="updateUserInfo">
        </NewExtradata>

        <Notes/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NewExtradata from './NewExtradata'
import VBFieldEditor from './VBFieldEditor'
import Notes from '@/pages/App/Conversations/components/Notes.vue'
import countries from '@/libs/countries'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser.vue'
export default {
  components: { NewExtradata, Notes, VBFieldEditor, ViewUser },
  computed: {
    ...mapGetters(['conversationsIsConnected', 'userExtraDatasConversations', 'appUuid', 'tenebitIntegration']),
    ...mapState({
      roomInfo: state => state.conversations.roomInfo,
      user: state => state.conversations.user
    }),
    imageProfile () {
      if (this.errorImageProfile) return ''
      return this.user.image
    },
    tenebitUrl () {
      if (this.tenebitIntegration) {
        return this.tenebitIntegration.label
      }
      return false
    }
  },
  created () {
    this.getUserDetails()
  },
  data: () => ({
    country: null,
    error: {
      icon: '',
      message: '',
      show: false
    },
    customComponent: 'Profile',
    errorImageProfile: false,
    loadingUserDetails: false,
    authsSelectedUser: [],
    viewUserDialog: false
  }),
  methods: {
    clearUserIdAndAuths () {
      this.authsSelectedUser = []
      this.getUserDetails()
    },
    async getUserDetails () {
      if (!this.roomInfo) {
        this.error = {
          message: this.$t('general.selectPerson'),
          icon: 'feather-user',
          show: true
        }

        return
      }
      if (!this.roomInfo.userGuest) {
        this.error = {
          message: this.$t('general.anonymousPerson'),
          icon: 'mdi-incognito',
          show: true
        }

        return
      }

      try {
        this.loadingUserDetails = true
        const userId = this.roomInfo.user ? this.roomInfo.user.userGuest || this.roomInfo.userGuest : this.roomInfo.userGuest

        let response

        if (userId[0] === '+') {
          response = await this.$store.dispatch('getUserByPhoneRoom', userId.substring(1))
        } else {
          response = await this.$store.dispatch('getUserDetails', { userId })
        }

        this.$store.commit('SET_CONVERSATIONS_USER', response.user)

        const { country } = this.user
        if (country) {
          this.country = countries.find(item => item.code === country.toLowerCase())
        } else {
          this.country = {
            country: 'Colombia',
            code: 'co',
            number: '57'
          }
        }

        this.loadingUserDetails = false

        this.error = {
          message: '',
          icon: '',
          show: false
        }
      } catch (e) {
        this.loadingUserDetails = false
        this.error = {
          message: this.$t('general.noDataFound'),
          icon: 'feather-user',
          show: true
        }
      }
    },
    goBackToConversation () {
      this.$emit('changeCurrentComponent', 'ConversationContainer')
    },
    onErrorImage () {
      this.errorImageProfile = true
    },
    showUser (component) {
      this.authsSelectedUser = Object.entries(this.user.auths).length > 0 ? this.user.auths : null
      this.customComponent = component
      this.viewUserDialog = true
    },
    async updateUser (info) {
      try {
        const data = {
          userId: this.user.userId
        }
        data[info.field] = info.value
        await this.$store.dispatch('updateUser', data)
      } catch (e) {
        console.error(e)
      }
    },
    async updateUserInfo (event) {
      try {
        const data = {
          userId: this.user.userId,
          extradata: [{
            field: event.field,
            value: event.value
          }]
        }

        const response = await this.$store.dispatch('updateUserExtradata', data)
        this.$store.commit('SET_CONVERSATIONS_USER', response.user)
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    }
  },
  watch: {
    roomInfo (value) {
      if (!value) {
        this.$store.commit('SET_CONVERSATIONS_USER', '')
        this.$store.commit('SET_ROOM_INFO', '')
      }
      this.getUserDetails()
    }
  }
}
</script>

<style lang="scss">
  @import "../../../styles/Conversations/DetailsContainer.scss";
</style>
